import React from 'react';
import { Bar } from 'react-chartjs-2';

function OffensesByHourChart({ data }) {
  // Ensure all 24 hours are present
  const hours = Array.from({ length: 24 }, (_, i) => i); // 0-23
  const processedData = hours.map(hour => {
    const apiHour = data.find(d => parseInt(d.hour_of_day, 10) === hour);
    return apiHour ? parseInt(apiHour.count, 10) : 0;
  });

  const chartData = {
    labels: hours.map(h => `${h}:00`),
    datasets: [{
      label: 'Offenses by Hour of Day',
      data: processedData,
      backgroundColor: 'rgba(54, 162, 235, 0.6)', // blue
      borderColor: 'rgba(54, 162, 235, 1)',
      borderWidth: 1,
    }],
  };

  return <Bar data={chartData} options={{ responsive: true }} />;
}

export default OffensesByHourChart;